<template>
  <div id="footer" class="container-fluid">
    <p class="address_tel_fax">
      <span>地址：佛山市南海区里水镇胜利社区里水东部工业园路38号之2宏成合创（南海）智慧产业园-5号厂房第5层503号</span>
    </p>
    <p class="copy">Copyright &copy; 2025 佛山领创未来信息技术有限公司</p>
    <a class="link" @click="toICP">粤ICP备2025463974号-1</a>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    toICP() {
      window.open('https://beian.miit.gov.cn')
    }
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
.link {
  color: white;
  cursor: pointer;
}
.link:hover {
  color: white;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue